import React from 'react';
import { FrontEdgeLogo } from '../../../../components/icons';
import { Field, Form, Formik } from 'formik';
import Input from '../../../../components/input/Input';
import Button from '../../../../components/button/Button';
import { CurrentUserProfile } from '../../../../interfaces/User';
import { useNavigate } from 'react-router-dom';

export const SplashStep2 = ({
    onContinue,
    userDetails,
    accountFound,
    setAccountFound
}: {
    onContinue: () => void;
    userDetails: CurrentUserProfile;
    accountFound: boolean;
    setAccountFound: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
    const initialValues = {
        companyName: userDetails?.corporate?.businessName || '',
        rcNumber: userDetails?.corporate?.rcNumber || ''
    };
    const navigate = useNavigate();

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={(values) => {
                setAccountFound((prev) => {
                    const newValue = !prev;
                    if (newValue) {
                        onContinue();
                    } else {
                        navigate('/onboarding/investment');
                    }

                    return newValue;
                });
            }}
        >
            {({ values, errors, touched, setFieldValue }) => (
                <Form className='w-full space-y-6 pb-6 relative'>
                    <FrontEdgeLogo size='120' />
                    <div className='text-center space-y-2'>
                        <h2 className='font-medium text-[20px]'>
                            Let's get started
                        </h2>
                        <p className='text-midnightHaze text-[16px]'>
                            To continue, validate your corporate account:
                        </p>
                    </div>

                    <div className='mb-6 space-y-4 px-5 w-full'>
                        <Field
                            as={Input}
                            isError={
                                touched?.companyName && errors?.companyName
                            }
                            errorMessage={
                                touched?.companyName && errors?.companyName
                            }
                            required
                            type='text'
                            id='connect-companyName'
                            label='Registered company name'
                            name='companyName'
                            onChange={(
                                e: React.ChangeEvent<HTMLInputElement>
                            ) => {
                                setFieldValue('companyName', e.target.value);
                            }}
                        />

                        <Field
                            as={Input}
                            isError={touched?.rcNumber && errors?.rcNumber}
                            errorMessage={touched?.rcNumber && errors?.rcNumber}
                            required
                            type='text'
                            id='connect-rcNumber'
                            label='RC Number'
                            name='rcNumber'
                            onChange={(
                                e: React.ChangeEvent<HTMLInputElement>
                            ) => {
                                setFieldValue('rcNumber', e.target.value);
                            }}
                        />

                        <div className='pt-6'>
                            <Button
                                type='submit'
                                text='Continue'
                                className='w-full'
                            />
                        </div>
                    </div>
                </Form>
            )}
        </Formik>
    );
};
